import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { recommendations, genreFilters } from "@/mocks/recommendations";

export default function Recommendations() {
  const [activeGenre, setActiveGenre] = useState("全部");

  const list = useMemo(
    () =>
      activeGenre === "全部"
        ? recommendations
        : recommendations.filter((item) => item.genre === activeGenre),
    [activeGenre],
  );

  return (
    <section id="recommend" className="w-full px-4 py-16 md:px-8 md:py-24">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="当季新番推荐"
          title="按题材挑选你的追番目标"
          description="下面每部作品都标注了题材、集数与阶段口碑。用标签缩小范围，快速找到符合口味的新番。"
        />
        <div className="flex flex-wrap gap-2">
          {genreFilters.map((genre) => {
            const active = genre === activeGenre;
            return (
              <button
                key={genre}
                type="button"
                onClick={() => setActiveGenre(genre)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900"
                }`}
              >
                {genre}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {list.map((item) => (
          <article
            key={item.id}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
              <img
                src={item.image}
                alt={item.alt}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                {item.genre}
              </span>
              <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-[11px] text-background-50">
                <i className="ri-star-fill text-accent-400" />
                {item.score}
              </span>
            </div>

            <div className="flex flex-1 flex-col p-4">
              <h3 className="text-base text-foreground-950">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">{item.subtitle}</p>
              <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-600">
                {item.summary}
              </p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-play-list-2-line" />
                  {item.episodes}
                </span>
                <span
                  className={`rounded-full px-2.5 py-1 ${
                    item.status === "连载中"
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-100 text-foreground-600"
                  }`}
                >
                  {item.status}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>

      {list.length === 0 ? (
        <p className="mt-10 rounded-lg border border-dashed border-background-300 py-12 text-center text-sm text-foreground-500">
          该题材下暂无收录作品，试试其他标签。
        </p>
      ) : null}
    </section>
  );
}